<template>
  <InternalLayout>
    <header class="header">
      <SmallHeader tag="h1">Find a hospital</SmallHeader>
      <HeaderText tag="div">Let's find a hospital. You are a:</HeaderText>
    </header>
    <form class="form-step" @submit.prevent="onSubmit">
      <CheckboxGrid
        :options="flowOptions"
        :selected="[flow]"
        @change="onCheck"
      />
      <BaseButton variant="primary" class="submit-btn" :disabled="!flow">
        Next
      </BaseButton>
    </form>
  </InternalLayout>
</template>

<script>
import BaseButton from '@/components/base-button';
import CheckboxGrid from '@/components/checkbox-grid';
import HeaderText from '@/components/header-text';
import InternalLayout from '@/components/internal-layout';
import SmallHeader from '@/components/small-header';
import { RouterAliases } from '@/router';

export default {
  components: {
    BaseButton,
    CheckboxGrid,
    HeaderText,
    InternalLayout,
    SmallHeader,
  },
  data() {
    return {
      flow: null,
    };
  },
  computed: {
    flowOptions() {
      return [
        {
          label: 'Patient',
          value: 'patient',
        },
        {
          label: 'Doctor or EMT',
          value: 'doctor',
        },
      ];
    },
  },
  methods: {
    onCheck({ isChecked, value }) {
      if (isChecked) {
        this.flow = value;
      }
      if (!isChecked && this.flow === value) {
        this.flow = null;
      }
    },
    onSubmit() {
      if (!this.flow) return;
      this.$router.push({
        name:
          this.flow === 'patient'
            ? RouterAliases.PATIENT_ASSESSMENT
            : RouterAliases.DOCTOR_ASSESSMENT,
        params: {
          step: 1,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  text-align: center;
}

.header-text {
  margin: 24px 0;
}

.form-step {
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;

  @media screen and (min-width: 768px) {
    max-width: 100%;
    width: 542px;
  }
}

.submit-btn {
  margin-top: auto;
}
</style>
